const { getSlugForRoute } = require('../../routes/getPageInformation');
const { ROUTES } = require('../../../constants/routes');

module.exports.buildThankYouSlug = (orderId) =>
  `${getSlugForRoute(ROUTES.THANK_YOU)}?order=${orderId}`;
